const CareerPathwaysLrapLayout = <template>{{outlet}}</template>;

export default CareerPathwaysLrapLayout;
